import { ref } from 'vue';
import { getCargoItemApi } from '@/request/APIs/co';
function useCargoNameOptions(para) {
    const cargoNames = ref([]);
    getCargoItemApi(para).then(res => {
        cargoNames.value = Object.keys(res.data.data).map(name => ({
            label: res.data.data[name],
            value: parseFloat(name)
        }));
    });
    return {
        cargoNames
    };
}
export default useCargoNameOptions;
